import React from 'react';
import { ImagePlaceholder, SectionWrapper, CTAButton, StarRating } from './ui';
import { Lock, Truck, ShieldCheck, AlertTriangle } from 'lucide-react';
export const OfferBlock = () => {
  return <div id="offer" className="scroll-mt-10" data-id="element-82">
      <SectionWrapper className="py-16 bg-white" isWide={true} data-id="element-83">
        <div className="max-w-4xl mx-auto" data-id="element-84">
          <h2 className="text-3xl md:text-4xl font-serif text-primary font-bold mb-10 text-center" data-id="element-85">
            How to Get Your LEVANCE™ Today
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-16" data-id="element-86">
            {['Tap Check Availability. See if LEVANCE is still in stock at the introductory price.', 'Choose your color and add to cart. Free shipping. Ships within 24–48 hours.', "Clip it on. One long-press of the button. That's it. Runs for days on a single charge.", 'Get the summer back. The back door stays open. The bedtime comb goes from 14 minutes to 4.'].map((text, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-87">
                <div className="w-10 h-10 bg-sage text-primary font-serif font-bold text-xl rounded-full flex items-center justify-center mb-4" data-id="element-88">
                  {i + 1}
                </div>
                <p className="text-sm font-medium text-foreground/80" data-id="element-89">{text}</p>
              </div>)}
          </div>

          <div className="bg-background border-2 border-primary rounded-sm overflow-hidden shadow-lg" data-id="element-90">
            <div className="bg-primary text-white text-center py-3 font-bold tracking-wider text-sm" data-id="element-91">
              BUY 1 GET 1 FREE · ⚡ LIMITED TIME — INTRODUCTORY PRICING
            </div>

            <div className="p-6 md:p-10 flex flex-col md:flex-row gap-10 items-center" data-id="element-92">
              <div className="w-full md:w-1/2" data-id="element-93">
                <div className="w-full aspect-square overflow-hidden rounded-sm border border-sage bg-white" data-id="element-94">
                  <img src="https://cdn.magicpatterns.com/uploads/qcFHmZyGWmjmMhXZoV4yCr/edfdd753-3bf3-4a77-ab3b-6f317fac1c15.png" alt="LEVANCE™ Ultrasonic Tick Repellent in Black and White" className="w-full h-full object-cover" data-id="element-95" />
                </div>
              </div>

              <div className="w-full md:w-1/2 flex flex-col" data-id="element-96">
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-primary mb-2" data-id="element-97">
                  LEVANCE™ Ultrasonic Tick Repellent
                </h3>
                <p className="text-lg font-medium text-accent mb-4" data-id="element-98">
                  Buy One, Get One Free — Available in Black or White
                </p>

                <div className="flex items-center gap-2 mb-6" data-id="element-99">
                  <StarRating rating={4.8} data-id="element-100" />
                  <span className="text-sm font-medium text-foreground/70" data-id="element-101">
                    4.8 — 7,341 Verified Reviews
                  </span>
                </div>

                <div className="flex items-baseline gap-3 mb-6" data-id="element-102">
                  <span className="text-4xl font-bold text-foreground" data-id="element-103">
                    $39.90
                  </span>
                  <span className="text-xl text-foreground/50 line-through decoration-2" data-id="element-104">
                    $98.00
                  </span>
                </div>

                <ul className="space-y-3 mb-8 text-[15px] font-medium text-foreground/80" data-id="element-105">
                  <li className="flex items-start gap-2" data-id="element-106">
                    <span className="text-primary mt-0.5" data-id="element-107">✓</span> 2× LEVANCE™
                    devices (choose your colors at checkout)
                  </li>
                  <li className="flex items-start gap-2" data-id="element-108">
                    <span className="text-primary mt-0.5" data-id="element-109">✓</span> Lanyard +
                    Carabiner clip included with each
                  </li>
                  <li className="flex items-start gap-2" data-id="element-110">
                    <span className="text-primary mt-0.5" data-id="element-111">✓</span> USB-C
                    charging cable
                  </li>
                  <li className="flex items-start gap-2" data-id="element-112">
                    <span className="text-primary mt-0.5" data-id="element-113">✓</span> Quick-start
                    guide
                  </li>
                  <li className="flex items-start gap-2" data-id="element-114">
                    <span className="text-primary mt-0.5" data-id="element-115">✓</span> Free shipping
                  </li>
                  <li className="flex items-start gap-2" data-id="element-116">
                    <span className="text-primary mt-0.5" data-id="element-117">✓</span> 60-Day
                    Money-Back Guarantee — full refund, no interrogation
                  </li>
                </ul>

                <CTAButton className="w-full text-lg py-5 mb-4" data-id="element-118">
                  CHECK AVAILABILITY →
                </CTAButton>

                <div className="flex flex-wrap justify-center gap-4 text-xs font-medium text-foreground/60" data-id="element-119">
                  <span className="flex items-center gap-1" data-id="element-120">
                    <Lock className="w-3.5 h-3.5" data-id="element-121" /> Secure Checkout
                  </span>
                  <span className="flex items-center gap-1" data-id="element-122">
                    <Truck className="w-3.5 h-3.5" data-id="element-123" /> Free Shipping
                  </span>
                  <span className="flex items-center gap-1" data-id="element-124">
                    <ShieldCheck className="w-3.5 h-3.5" data-id="element-125" /> 60-Day Guarantee
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 space-y-4 max-w-3xl mx-auto" data-id="element-126">
            <p className="text-sm text-center text-foreground/70" data-id="element-127">
              This is a one-time purchase. There is no subscription. There are
              no refills. There is nothing to reapply. If we're sold out when
              you get to this page, we restock in batches and the next batch
              ships when the next batch ships — there is no waitlist priority
              and no rush option. If it's in stock right now, that's the window.
            </p>

            <div className="bg-accent/10 border border-accent/30 p-4 rounded-sm flex gap-3 text-sm text-foreground/80" data-id="element-128">
              <AlertTriangle className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-129" />
              <p data-id="element-130">
                <strong className="text-accent font-bold" data-id="element-131">
                  LEVANCE is priced at $39.90 for our Buy One, Get One Free
                  promotion
                </strong>{' '}
                — that's two devices for the price of one. This pricing is
                temporary and will not last. When this batch sells out, pricing
                resets. No rainchecks.
              </p>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </div>;
};
export const EmotionalClose = () => {
  return <SectionWrapper className="py-16" data-id="element-132">
      <div className="mb-10" data-id="element-133">
        <div className="w-full aspect-[16/9] overflow-hidden rounded-sm border border-sage" data-id="element-134">
          <img src="https://cdn.magicpatterns.com/uploads/htrDd7WTQ9SS4bN34QA2u6/19aaf30c-cb21-43c9-bf44-010a8713445c.png" alt="A mother and her six-year-old daughter sitting together on a back porch step at dusk, gazing out across tall summer grass toward a treeline lit by warm fading golden light. Fireflies beginning to appear. Peaceful, reclaimed." className="w-full h-full object-cover" data-id="element-135" />
        </div>
      </div>

      <h2 className="text-3xl md:text-4xl font-serif text-primary font-bold mb-8 text-center" data-id="element-136">
        Remember… This Isn't Just About You.
      </h2>

      <div className="space-y-6 text-[17px] leading-[1.6] text-foreground/90 mb-12" data-id="element-137">
        <p data-id="element-138">
          It's about the six-year-old who hasn't been told yet that she can
          never eat a birthday-party hot dog again.
        </p>
        <p data-id="element-139">
          It's about the nine-year-old at soccer practice on the field you can't
          pre-spray.
        </p>
        <p data-id="element-140">
          It's about the dog who can't be sprayed at all and who keeps bringing
          the problem back into the house.
        </p>
        <p data-id="element-141">
          It's about the husband who thinks you're "too much about this" — who
          would think differently if he'd watched what you watched in the
          pediatrician's office last August.
        </p>
        <p data-id="element-142">
          It's about the version of you who used to run barefoot at your
          grandmother's place and who would like, very much, to give some
          version of that back to her own kids before they're too old to want
          it.
        </p>

        <div className="py-4" data-id="element-143">
          <p data-id="element-144">
            You can't make the Lone Star tick go back south. You can't unmake
            alpha-gal. You can't undo the fact that the rules changed underneath
            us while we were busy being good parents with the tools we
            inherited.
          </p>
        </div>

        <p data-id="element-145">
          But you can close the gap. Tonight. Before the next soccer Saturday.
          Before the next field trip you can't pre-spray for. Before the next
          freckle at 11:14 p.m.
        </p>
        <p data-id="element-146">
          You've been the early one. You've been the paranoid one. You've been
          the one carrying the mental load alone.
        </p>

        <p className="text-xl font-bold text-primary mt-8 text-center" data-id="element-147">
          Clip one on. Take a breath. Get the summer back.
        </p>
      </div>

      <div className="text-center mb-12" data-id="element-148">
        <CTAButton className="w-full sm:w-auto text-lg py-5 px-10" data-id="element-149">
          CHECK AVAILABILITY →
        </CTAButton>
      </div>

      <div className="bg-white border border-sage p-4 rounded-sm flex items-center justify-between gap-4 max-w-md mx-auto shadow-sm" data-id="element-150">
        <div className="w-16 h-16 shrink-0 overflow-hidden rounded-sm border border-sage bg-white" data-id="element-151">
          <img src="https://cdn.magicpatterns.com/uploads/qcFHmZyGWmjmMhXZoV4yCr/edfdd753-3bf3-4a77-ab3b-6f317fac1c15.png" alt="LEVANCE™ Ultrasonic Tick Repellent" className="w-full h-full object-cover" data-id="element-152" />
        </div>
        <div className="flex-1" data-id="element-153">
          <StarRating rating={5} className="scale-75 origin-left mb-1" data-id="element-154" />
          <div className="text-xs font-medium text-foreground/70 mb-1" data-id="element-155">
            7,341 Reviews
          </div>
          <div className="text-sm font-bold" data-id="element-156">
            $39.90{' '}
            <span className="text-foreground/50 line-through font-normal ml-1" data-id="element-157">
              $98.00
            </span>
          </div>
        </div>
        <CTAButton className="py-2 px-4 text-xs whitespace-nowrap" data-id="element-158">
          ORDER NOW →
        </CTAButton>
      </div>
    </SectionWrapper>;
};